import { Outlet, Navigate } from "react-router-dom";

export default function ChatLayout() {
  return <Outlet />;
}
